//Generator Url: http://localhost:8033/api/ocrorder/getapi
import request from '~/utils/request';
//import './OCROrderApi.d';
export namespace OCROrderApi {
    export const takeList = (m: IOCROrderQuery, loadingOptions?: IRequestLoadingOption) => request<IPagedResultData<IOcrOrderListItem>>({
        method: 'post',
        url: 'OCROrder/TakeList',
        data: m,
        loadingOptions
    })

    export const queryDetail = (m: IOCROrderQuery, loadingOptions?: IRequestLoadingOption) => request<IPagedResultData<ISimpleDetailList>>({
        method: 'post',
        url: 'OCROrder/QueryDetail',
        data: m,
        loadingOptions
    })

    export const getDetail = (id: number, loadingOptions?: IRequestLoadingOption) => request<IOcrOrderListItemWithDetail>({
        method: 'get',
        url: 'OCROrder/GetDetail',
        params: { id },
        loadingOptions
    })

    export const getLineDetail = (orderId: number, lineId: number, loadingOptions?: IRequestLoadingOption) => request<IOcrOrderListItemWithDetail>({
        method: 'get',
        url: 'OCROrder/GetLineDetail',
        params: { orderId, lineId },
        loadingOptions
    })

    export const edit = (param: IOcrOrderReceiptItem, loadingOptions?: IRequestLoadingOption) => request<void>({
        method: 'post',
        url: 'OCROrder/Edit',
        data: param,
        loadingOptions
    })

    export const setPass = (receiptInfoId: number, loadingOptions?: IRequestLoadingOption) => request<void>({
        method: 'get',
        url: 'OCROrder/SetPass',
        params: { receiptInfoId },
        loadingOptions
    })

    export const updateField = (m: IOCRFileUpdateParam, loadingOptions?: IRequestLoadingOption) => request<void>({
        method: 'post',
        url: 'OCROrder/UpdateField',
        data: m,
        loadingOptions
    })

    export const saveOrder = (item: IOcrOrderEditItem, loadingOptions?: IRequestLoadingOption) => request<number>({
        method: 'post',
        url: 'OCROrder/SaveOrder',
        data: item,
        loadingOptions
    })

    export const del = (id: number, loadingOptions?: IRequestLoadingOption) => request<void>({
        method: 'get',
        url: 'OCROrder/Delete',
        params: { id },
        loadingOptions
    })

    export const deleteLine = (ids: Array<number>, loadingOptions?: IRequestLoadingOption) => request<void>({
        method: 'post',
        url: 'OCROrder/DeleteLine',
        data: ids,
        loadingOptions
    })

    export const getOrderBaseInfo = (id: number, loadingOptions?: IRequestLoadingOption) => request<IOcrOrderViewItem>({
        method: 'get',
        url: 'OCROrder/GetOrderBaseInfo',
        params: { id },
        loadingOptions
    })

    export const exportExcel = (param: IOCROrderQuery, loadingOptions?: IRequestLoadingOption) => request<NString>({
        method: 'post',
        url: 'OCROrder/ExportExcel',
        data: param,
        loadingOptions
    })

    export const getSeviceTime = (loadingOptions?: IRequestLoadingOption) => request<NString>({
        method: 'get',
        url: 'OCROrder/GetSeviceTime',
        loadingOptions
    })

    // ------------ model define ------------- //


    export interface IOcrOrderEditItem {

        Id: number
        /**是否自定义订单
        *System.Boolean*/
        IsCustom: boolean

        Location?: NString

        Remark?: NString

        FileSessionId?: string
    }

    /**此标记不直接使用
    *ZnlSoft.Scm.DBModels.Interfaces.Base.IUserRealName*/
    export interface IOcrOrderViewItem extends IOcrOrderEditItem {

        CreatedUserId: number

        CreatedUser?: NString

        UpdatedUserId: number

        UpdatedUser?: NString

        OrderNo?: NString

        CreatedAt?: NString
    }

    /**此标记不直接使用
    *ZnlSoft.Scm.DBModels.Interfaces.Base.IUserRealName*/
    export interface IOcrOrderListItem extends IOcrOrderViewItem {

        Line: number

        Photo: number
    }

    /**分页请求实体类
    *ZnlSoft.Scm.Core.Models.PageParam*/
    export interface IPageParam {
        /**分页的页码
        *System.Int32*/
        Page: number
        /**分页的每页数据项数(PageSize)
        *System.Int32*/
        Limit: number
    }


    export const enum KeyType {
        Location = 0,
        OrdrNo = 1,
        PartNo = 2,
        CartonNo = 3,
        PalletNo = 4,
        OrderRemark = 5,
        DetailRemark = 6
    }


    export interface IOCROrderQuery extends IPageParam {

        Id: number

        Type: KeyType

        Keyword?: NString
    }


    export interface ISimpleDetailList {

        Id: number

        PartNo?: NString

        CaseNo?: NString

        PalletNo?: NString

        Location?: NString
    }


    export const enum PackagingUnit {
        /**未指定包装（散包）*/
        None = 0,
        /**盒子*/
        Box = 1,
        /**袋子*/
        Bag = 2,
        /**箱子*/
        Case = 3,
        /**条*/
        Strip = 4,
        /**卷盘*/
        Reel = 5,
        /**托盘*/
        Pallet = 6
    }


    export interface IReceiptPackagingInfo {

        PCS: number

        AsKilo: boolean

        Qty: number

        AgentOrderDetailReceiptInfoId: number

        Type: PackagingUnit
    }


    export const enum AODRIFields {
        PartNo = 1,
        Brand = 2,
        DateCode = 4,
        RegionName = 8,
        Qty = 16,
        CaseNo = 32,
        PalletNo = 64,
        Remark = 128,
        CheckStatus = 256,
        PhotoStatus = 512,
        UserRemark = 1024,
        Package = 2048
    }


    export const enum PhotoStatus {
        Good = 0,
        /**不清晰*/
        Unclear = 1,
        /**无可用内容，拍错标签了*/
        NoContent = 2
    }

    /**电子元件交易扩展数据接口，用于存储交易相关的各类统计和参考数据
    *ZnlSoft.Scm.Frontend.Services.OcrOrder.IReceiptItemExtarnData*/
    export interface IOcrOrderReceiptItem {

        Id: number

        PartNo?: NString

        Brand?: NString

        OrderId: number

        Qty: number

        RegionName?: NString

        DateCode?: NString

        AgentOrderDetailId: number

        CaseNo?: NString

        PackagingInfos: Array<IReceiptPackagingInfo>

        Photos: number

        Remark?: NString

        UserId: number

        UpdatedUser?: NString

        PalletNo?: NString

        FieldChange: AODRIFields

        UpdatedAt?: NString

        CreatedUserId: number

        CreatedAt?: NString

        CreatedUser?: NString

        CheckStatus: number

        PhotoStatus: PhotoStatus

        UserRemark?: NString

        FileSession?: string

        Package?: NString
        /**近期交易量
        *System.Decimal*/
        RecentTransaction: number
        /**交易频率
        *System.Decimal*/
        TradeFrequency: number
        /**参与公司数量，参与该元件交易的公司总数
        *System.Decimal*/
        JoinCompany: number
        /**元件类别
        *System.String*/
        Category?: NString
        /**标准价格，元件的标准定价或参考价格
        *System.Decimal*/
        StdPrice: number
        /**参考价格
        *System.Decimal*/
        RefPrice: number

        RefAmount: number
        /**立创价格
        *System.Decimal*/
        LcPrice: number
        /**交易持续性
        *System.Decimal*/
        TradeSustain: number
        /**BOM.AI搜索指数
        *System.Int32*/
        BomAiSearchIndex: number
    }

    /**此标记不直接使用
    *ZnlSoft.Scm.DBModels.Interfaces.Base.IUserRealName*/
    export interface IOcrOrderListItemWithDetail extends IOcrOrderListItem {

        Detail: Array<IOcrOrderReceiptItem>
    }

    /**一般的单字段修改
    *ZnlSoft.Scm.Core.ParamModels.UpdateFieldsParam`2[K,V]*/
    export interface IUpdateFieldsParam<K, V> {

        Id: Array<K>

        Value: V
    }


    export interface IOCRFileUpdateParam extends IUpdateFieldsParam<number, NString> {

        Field: AODRIFields
    }

}
export default OCROrderApi